import { useEffect, useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import {
  AlertDialog,
  DialogResult
} from '../../../../../../components/analytics';
import { Scenario } from '../../../scenarios/types/scenario.model';
import { setScenario } from '../../../home/store/simulator-home-slice';
import ScenarioCreateSuccessDialog from '../../../home/components/scenario-create-success/scenario-create-success-dialog';
import { clearCogsInputs } from '../../store/planner-slice';
import _ from 'lodash';

interface ISimulatorFooterRequiredProps {
  nextClickHandler: () => void;
  isButtonSectionVisible: boolean;
}

interface ISimulatorFooterDefaultProps {
  isSimulationDisabled?: boolean;
  isResetSimulationDisabled?: boolean;
  isNextDisabled?: boolean;
  simulationClickHandler?: () => void;
  resetSimulationHandler?: () => void;
  isNextButtonHidden?: boolean;
}

interface ISimulatorFooterProps
  extends ISimulatorFooterRequiredProps,
    ISimulatorFooterDefaultProps {}

function CogsFooter({
  onSubmitClick,
  onResetClick,
  onClearClick,
  isTableDataFetched,
  closeCogs,
  isSubmitCogsEnabled,
  isClearEnabled
}) {
  const simulationDetails = JSON.parse(
    localStorage.getItem('enableSimulation')
  );
  const appDispatch = useAppDispatch();
  const [isUpdateScenarioDialogOpen, setIsUpdateScenarioDialogOpen] =
    useState(false);
  const [isScenarioUpdatedSuccessfully, setScenarioUpdatedSuccessfully] =
    useState(false);

  // getting state of current scenario details
  const { moduleAccessMap } = useAppSelector((state) => state.simulatorHome);
  // getting isSubmitEnabled  from current scenario
  const isSubmitEnabled = moduleAccessMap?.['kpi_update']?.['submit'];
  // getting isResetEnabled  from current scenario
  const isResetEnabled = moduleAccessMap?.['kpi_update']?.['reset_to_default'];

  return (
    <>
      <Grid
        container
        justifyContent='flex-end'
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: (theme) => theme.palette.common.white,
          padding: '4px 8px',
          zIndex: 2
        }}
      >
        <Grid
          p={1}
          item
          xs={4}
          container
          spacing={1}
          justifyContent='end'
          alignItems='center'
        >
          <Button
            sx={{ ml: 1 }}
            variant='contained'
            onClick={onSubmitClick}
            disabled={
              isTableDataFetched || !isSubmitEnabled || !isSubmitCogsEnabled
            }
          >
            Submit
          </Button>
          <Button
            sx={{ ml: 1 }}
            variant='outlined'
            onClick={onResetClick}
            disabled={isTableDataFetched || !isResetEnabled}
          >
            Reset to default
          </Button>

          <Button
            variant='outlined'
            onClick={onClearClick}
            sx={{ ml: 1 }}
            disabled={isTableDataFetched || !isClearEnabled}
          >
            Clear
          </Button>
          <Button
            variant='outlined'
            onClick={closeCogs}
            sx={{ ml: 1 }}
            disabled={isTableDataFetched}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </>
  );
}

export default CogsFooter;
